import * as appsync from "./appsync.js";
import { createAtom } from "./fable_modules/fable-library.4.10.0/Util.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/./SimpleJson.fs.js";
import { fromBase64String } from "./fable_modules/fable-library.4.10.0/String.js";
import { get_UTF8 } from "./fable_modules/fable-library.4.10.0/Encoding.js";
import { Convert_fromJson } from "./fable_modules/Fable.SimpleJson.3.24.0/./Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/./TypeInfo.Converter.fs.js";
import { QuizChangedEvent_$reflection } from "../shared/Shared.fs.js";
import { map } from "./fable_modules/fable-library.4.10.0/Array.js";

export function configure(endpoint, region, apikey) {
    appsync.configure(endpoint, region, apikey);
}

export let subscriptionId = createAtom(void 0);

export function subscribe(quizId, token, onSuccess, onError) {
    const sid = appsync.subscribe(quizId, token, (msg) => {
        let matchValue, bytes, objectArg;
        onSuccess((matchValue = SimpleJson_tryParse((bytes = fromBase64String(msg.body), (objectArg = get_UTF8(), objectArg.getString(bytes)))), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(QuizChangedEvent_$reflection())) : (() => {
            throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
        })()));
    }, (errors) => {
        onError(map((err) => err.message, errors));
    }) | 0;
    subscriptionId(sid);
}

export function unsubscribe() {
    if (subscriptionId() == null) {
    }
    else {
        const sid = subscriptionId() | 0;
        appsync.unsubscribe(sid);
        subscriptionId(void 0);
    }
}

